import axiosInstance from '../AxiosInstance';

export type AppSettingDto = {
    id: string;
    appName: string;
    moduleKey: string;
    moduleName: string;
    isEnabled: boolean;
};

export const getAppSettingsByAppName = (appName: string) =>
    axiosInstance.get<AppSettingDto[]>('/app-settings', {
        params: { appName },
    });
